// @ts-strict-ignore

import {
  Component,
  Input
} from "@angular/core";

@Component({
  selector: 'lm-drill-view-pdf',
  standalone: false,
  template: `
      <div class="lm-is-indent field">
          <div class="fieldset-title">{{info.dataView.representativeText}}</div>
          <a soho-hyperlink
              class="lm-hyperlink"
              href="{{info.drillAction.drillUrl}}"
              target="_blank">{{info.drillAction.drillName}}</a>
      </div>
  `
})
export class LMDrillViewPdfComponent {
  @Input() info!: LMDrillAroundViewInfo;

  constructor() {
  }
}
